import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Actions from "../redux/actions";
import { EventData } from "./EventPage";
import toast from "react-hot-toast";
import { env } from "../config";
import Loader from "../components/Loader";
import Footer from "../components/Footer";

const EventIndividualPage = () => {
  const { key } = useParams();
  const [loading, setloading] = useState(false);

  const dispatch = useDispatch();

  const [currentEvent, setCurrentEvent] = useState<
    EventData["attributes"] | null
  >(null);

  const eventData: EventData[] = useSelector(
    (state: any) => state?.Page?.EventPageData
  );
  const getEventData = async () => {
    setloading(true);
    await axios
      .get(`${env}/api/events?populate=deep`)
      .then(function (response) {
        dispatch(Actions.EventPageAction(response?.data?.data));
      })
      .finally(() => {
        setloading(false);
      });
  };

  const findCurrentPage = () => {
    const currentEvent = eventData?.filter(
      (event) =>
        event?.attributes?.url?.toLowerCase().replace(/\s+/g, "-") === key
    )[0];
    if (!currentEvent) return;
    setCurrentEvent(currentEvent?.attributes);
  };

  useEffect(() => {
    if (eventData?.length === 0) {
      getEventData();
    } else {
      findCurrentPage();
    }
    window.scrollTo({
      top: 0,
      left: 1,
      behavior: "smooth",
    });
  }, [key, eventData]);

  return loading || !currentEvent ? (
    <Loader />
  ) : (
    <div>
      <div
        style={{
          backgroundImage: `url(${env}/uploads/1613_4db4f759d0.webp)`,
        }}
        className="px-5 md:px-20 relative font-custom bg-no-repeat bg-cover text-white h-[150%] md:h-[400px] lg:h-[500px] bg-center flex flex-col justify-center items-center"
      >
        <div className="h-full w-full flex flex-col justify-center items-start gap-4 my-7 md:mt-0 max-w-screen-2xl">
          <div className="text-lg md:text-xl font-bold tracking-wide uppercase">
            Event
          </div>

          <div
            data-aos="zoom-out"
            className="font-bold text-3xl md:text-4xl lg:text-6xl xl:text-7xl leading-tight"
          >
            {currentEvent?.title}
          </div>

          <div className="flex items-center gap-2 text-sm md:text-base bg-white text-black-75 p-2 rounded-md">
            <p className="font-bold">Date:</p>
            <p className="font-medium">{currentEvent?.eventDates}</p>
          </div>

          <div className="flex items-center gap-2 text-sm md:text-base bg-white text-black-75 p-2 rounded-md">
            <p className="font-bold">Location:</p>
            <p className="font-medium">{currentEvent?.location}</p>
          </div>
          {currentEvent?.booth && (
            <div className="flex items-center gap-2 text-sm md:text-base bg-white text-black-75 p-2 rounded-md">
              <p className="font-bold">Booth:</p>
              <p className="font-medium">{currentEvent?.booth}</p>
            </div>
          )}

          <div className=" gap-4 md:gap-6 mt-6 hidden lg:flex">
            {/* Copy SVG Button */}

            {/* Share SVG Button */}
            <button
              onClick={() => {
                navigator.clipboard.writeText(window?.location?.href);
                toast?.success("Copied Link To Clipboard");
              }}
              data-aos="flip-up"
              className="rounded-full border border-white p-3 sm:p-4"
            >
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 15.5C10.875 15.5 10.3437 15.2812 9.90625 14.8438C9.46875 14.4063 9.25 13.875 9.25 13.25C9.25 13.1625 9.25625 13.0717 9.26875 12.9777C9.28125 12.8842 9.3 12.8 9.325 12.725L4.0375 9.65C3.825 9.8375 3.5875 9.98425 3.325 10.0902C3.0625 10.1967 2.7875 10.25 2.5 10.25C1.875 10.25 1.34375 10.0312 0.90625 9.59375C0.46875 9.15625 0.25 8.625 0.25 8C0.25 7.375 0.46875 6.84375 0.90625 6.40625C1.34375 5.96875 1.875 5.75 2.5 5.75C2.7875 5.75 3.0625 5.803 3.325 5.909C3.5875 6.0155 3.825 6.1625 4.0375 6.35L9.325 3.275C9.3 3.2 9.28125 3.11575 9.26875 3.02225C9.25625 2.92825 9.25 2.8375 9.25 2.75C9.25 2.125 9.46875 1.59375 9.90625 1.15625C10.3437 0.71875 10.875 0.5 11.5 0.5C12.125 0.5 12.6563 0.71875 13.0938 1.15625C13.5312 1.59375 13.75 2.125 13.75 2.75C13.75 3.375 13.5312 3.90625 13.0938 4.34375C12.6563 4.78125 12.125 5 11.5 5C11.2125 5 10.9375 4.94675 10.675 4.84025C10.4125 4.73425 10.175 4.5875 9.9625 4.4L4.675 7.475C4.7 7.55 4.71875 7.63425 4.73125 7.72775C4.74375 7.82175 4.75 7.9125 4.75 8C4.75 8.0875 4.74375 8.178 4.73125 8.2715C4.71875 8.3655 4.7 8.45 4.675 8.525L9.9625 11.6C10.175 11.4125 10.4125 11.2655 10.675 11.159C10.9375 11.053 11.2125 11 11.5 11C12.125 11 12.6563 11.2188 13.0938 11.6562C13.5312 12.0937 13.75 12.625 13.75 13.25C13.75 13.875 13.5312 14.4063 13.0938 14.8438C12.6563 15.2812 12.125 15.5 11.5 15.5ZM11.5 3.5C11.7125 3.5 11.8905 3.42825 12.034 3.28475C12.178 3.14075 12.25 2.9625 12.25 2.75C12.25 2.5375 12.178 2.35925 12.034 2.21525C11.8905 2.07175 11.7125 2 11.5 2C11.2875 2 11.1095 2.07175 10.966 2.21525C10.822 2.35925 10.75 2.5375 10.75 2.75C10.75 2.9625 10.822 3.14075 10.966 3.28475C11.1095 3.42825 11.2875 3.5 11.5 3.5ZM2.5 8.75C2.7125 8.75 2.89075 8.678 3.03475 8.534C3.17825 8.3905 3.25 8.2125 3.25 8C3.25 7.7875 3.17825 7.60925 3.03475 7.46525C2.89075 7.32175 2.7125 7.25 2.5 7.25C2.2875 7.25 2.10925 7.32175 1.96525 7.46525C1.82175 7.60925 1.75 7.7875 1.75 8C1.75 8.2125 1.82175 8.3905 1.96525 8.534C2.10925 8.678 2.2875 8.75 2.5 8.75ZM11.5 14C11.7125 14 11.8905 13.928 12.034 13.784C12.178 13.6405 12.25 13.4625 12.25 13.25C12.25 13.0375 12.178 12.8595 12.034 12.716C11.8905 12.572 11.7125 12.5 11.5 12.5C11.2875 12.5 11.1095 12.572 10.966 12.716C10.822 12.8595 10.75 13.0375 10.75 13.25C10.75 13.4625 10.822 13.6405 10.966 13.784C11.1095 13.928 11.2875 14 11.5 14Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="text-black-75  px-5 py-7 md:px-10  lg:py-24 xl:py-32 grid lg:grid-cols-2 gap-5 max-w-screen-2xl mx-auto">
        <div className="flex flex-col items-start justify-center text-left order-2 md:order-3">
          <p className="text-2xl md:text-4xl font-custom font-bold text-black-75 mb-3">
            {currentEvent?.innerPageTitle}
          </p>
          {currentEvent?.innerPageDescription?.includes("**") ? (
            currentEvent?.innerPageDescription?.split("**")?.map((sentence) => {
              return (
                <p className="lg:text-lg md:text-base text-base  font-custom  pt-3 ">
                  {sentence}
                </p>
              );
            })
          ) : (
            <p className="lg:text-lg md:text-base text-base  font-custom  pt-3 ">
              {currentEvent?.innerPageDescription}
            </p>
          )}
          {currentEvent?.meetLink && (
            <div
              data-aos="flip-up"
              data-aos-easing="linear"
              data-aos-duration="500"
              className="flex justify-center mt-5"
            >
              <button
                onClick={() =>
                  window.open(
                    currentEvent?.meetLink,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                className=" bg-[#616161] text-white border border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-3"
              >
                {/* {ContactUsSection?.ButtonText}  */}
                Book Meetings
              </button>
              {/* </NavHashLink> */}
            </div>
          )}
        </div>
        <img
          width={currentEvent?.gallery?.data[0]?.attributes?.width}
          height={currentEvent?.gallery?.data[0]?.attributes?.height}
          className="rounded-md m-auto order-1 md:order-4"
          src={`${env}${currentEvent?.gallery?.data[0]?.attributes?.url}`}
          alt={currentEvent?.gallery?.data[0]?.attributes?.name}
        />
      </div>
      <div className={`bg-[#393939] px-5 py-7 lg:px-20 lg:py-14`}>
        <div
          data-aos="zoom-out"
          className={`text-2xl md:text-4xl lg:text-5xl flex justify-center text-white text-center  font-custom font-bold`}
        >
          Meet Our Team
        </div>
        <div
          data-aos="fade-down"
          className={`lg:text-lg md:text-base text-sm flex justify-center lg:w-[60%] 2xl:w-[50%] lg:mx-auto text-white text-center font-normal py-5`}
        >
          Connect with our experts to discuss your needs and explore potential
          collaborations.
        </div>
        {currentEvent?.meetLink && (
          <div
            data-aos="flip-up"
            data-aos-easing="linear"
            data-aos-duration="500"
            className="flex justify-center"
          >
            <button
              onClick={() =>
                window.open(
                  currentEvent?.meetLink,
                  "_blank",
                  "noopener,noreferrer"
                )
              }
              className=" bg-[#616161] text-white border border-[#616161] hover:bg-white hover:text-[#616161] hover:border hover:border-[#616161] rounded-[50px] w-max px-4 py-2 my-3"
            >
              {/* {ContactUsSection?.ButtonText}  */}
              Meet Us
            </button>
            {/* </NavHashLink> */}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default EventIndividualPage;
